"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const react = require("react");
const PacerContext = react.createContext(null);
const DEFAULT_OPTIONS = {};
function PacerProvider({
  children,
  defaultOptions = DEFAULT_OPTIONS
}) {
  const contextValue = react.useMemo(
    () => ({
      defaultOptions
    }),
    [defaultOptions]
  );
  return /* @__PURE__ */ jsxRuntime.jsx(PacerContext.Provider, { value: contextValue, children });
}
function usePacerContext() {
  return react.useContext(PacerContext);
}
function useDefaultPacerOptions() {
  const context = react.useContext(PacerContext);
  return context?.defaultOptions ?? {};
}
exports.PacerProvider = PacerProvider;
exports.useDefaultPacerOptions = useDefaultPacerOptions;
exports.usePacerContext = usePacerContext;
//# sourceMappingURL=PacerProvider.cjs.map
